(function () {
  'use strict';

  angular.module('eclipseApp.onboarding').directive('onboardingItem', OnboardingItem);

  function OnboardingItem() {
    return {
      restrict: 'E',
      scope: {
        config: '='
      },
      templateUrl: 'modules/onboarding/onboarding-item/onboarding-item.view.html',
      controller: 'onboardingItemController',
      controllerAs: 'ctrl',
      bindToController: true
    };
  }

})();
